import { useMemo, useState } from "react";

type UseFilterBySearchTextResponse<T> = {
  filteredItems: T[];
  searchText: string;
  setSearchText: (text: string) => void;
};

export const useFilterBySearchText = <T>(
  items: T[],
  properties: (keyof T)[],
) => {
  const [searchText, setSearchText] = useState<string>("");
  const filteredItems = useMemo(() => {
    return items
      .map((item) => {
        return {
          item: item,
          searchableText: properties
            .map((property) => {
              const value = item[property];
              if (typeof value === "string") {
                return value.toLowerCase();
              }
              return "";
            })
            .join(" "),
        };
      })
      .filter((combinedString) => {
        return combinedString.searchableText.includes(searchText.toLowerCase());
      })
      .map((combinedString) => combinedString.item);
  }, [items, properties, searchText]);

  return {
    filteredItems,
    searchText,
    setSearchText,
  } as UseFilterBySearchTextResponse<T>;
};
